// ✨ routes/AppRoutesUpdated.js - Рефакторинг с использованием AuthLayout
import React from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ContractProvider } from '../context/ContractContext';

import LoginForm from '../components/Auth/LoginForm';
import RegisterForm from '../components/Auth/RegisterForm';
import PrivateRoute, { GuestRoute } from '../components/common/PrivateRoute';
import DashboardUpdated from '../components/Dashboard/DashboardUpdated';
import TemplatesCatalog from '../components/Templates/TemplatesCatalog';
import ContractWizard from '../components/ContractWizard';
import LandingPage from '../components/LandingPage';
import ContactsPage from '../components/ContactsPage';
import UserAgreement from '../components/common/UserAgreement';
import PrivacyPolicyPage from '../components/common/PrivacyPolicyPage';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { PendingDraftReassuranceBanner } from '../components/common/AuthPrompt';
import '../styles/Auth.css';

// ✨ 1. Создаем чистый компонент-лейаут для страниц аутентификации
const AuthLayout = ({ children }) => (
    <div className="auth-layout">
        <div className="auth-layout-inner">
            <PendingDraftReassuranceBanner />
            {children}
        </div>
    </div>
);

const HomePage = () => <TemplatesCatalog />;

const AuthPage = ({ isRegister = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [showRegister, setShowRegister] = React.useState(isRegister);

    // Синхронизируем состояние с URL
    React.useEffect(() => {
        const isRegisterPath = location.pathname === '/register';
        setShowRegister(isRegisterPath);
    }, [location.pathname]);

    // Убираем скролл на страницах авторизации
    React.useEffect(() => {
        document.body.style.overflowY = 'hidden';
        document.documentElement.style.overflowY = 'hidden';
        
        return () => {
            document.body.style.overflowY = '';
            document.documentElement.style.overflowY = '';
        };
    }, []);

    const handleSuccess = (user) => {
        navigate('/dashboard');
    };

    const handleSwitchToRegister = () => {
        navigate('/register', { replace: true });
    };

    const handleSwitchToLogin = () => {
        navigate('/login', { replace: true });
    };

    return (
        <GuestRoute redirectTo="/dashboard">
            {/* ✨ 2. Оборачиваем контент в наш новый лейаут */}
            <AuthLayout>
                {showRegister ? (
                    <RegisterForm onSwitchToLogin={handleSwitchToLogin} onSuccess={handleSuccess} />
                ) : (
                    <LoginForm onSwitchToRegister={handleSwitchToRegister} onSuccess={handleSuccess} />
                )}
            </AuthLayout>
        </GuestRoute>
    );
};

const ContractEditorPage = () => (
    <ContractProvider>
        <ContractWizard />
    </ContractProvider>
);

const NotFoundPage = () => (
    <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1>404 - Страница не найдена</h1>
    </div>
);

const AppRoutesUpdated = () => {
    const { isInitializing } = useAuth();
    if (isInitializing) {
        return <LoadingSpinner message="Проверка авторизации..." fullScreen />;
    }
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<AuthPage isRegister={false} />} />
            <Route path="/register" element={<AuthPage isRegister={true} />} />
            <Route path="/templates" element={<TemplatesCatalog />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/offer" element={<UserAgreement />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route 
                path="/dashboard" 
                element={<PrivateRoute><DashboardUpdated /></PrivateRoute>} 
            />
            <Route 
                path="/contract/rent" 
                element={<ContractEditorPage />}
            />
            <Route path="/contract-wizard" element={<Navigate to="/contract/rent" replace />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutesUpdated;